import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './counter'
import systemReducer from './system'
import breadcrumbsReducer from './breadcrumbs'
import formatterReducer from './formatter'

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        system: systemReducer,
        breadcrumbs: breadcrumbsReducer,
        formatter: formatterReducer
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
